import React from 'react';
import { Link } from 'react-router-dom';
import { Linkedin } from 'lucide-react';

const linkCls =
  'text-body-muted hover:text-brand-blue text-[12px] font-bold uppercase tracking-[0.08em] whitespace-nowrap transition-colors';

const Footer = () => {
  return (
    <footer className="bg-white py-10">
      <div className="max-w-6xl mx-auto px-6 lg:px-8 flex flex-col lg:flex-row lg:items-center lg:justify-between gap-6">
        {/* Brand + tagline */}
        <div className="flex items-center gap-4 shrink-0">
          <Link to="/" className="font-black text-[20px] tracking-tight text-navy">
            5DBS
          </Link>
          <span className="text-body-muted text-[13.5px]">
            The revenue engine behind ambitious B2B media brands.
          </span>
        </div>

        {/* Nav — wraps cleanly, never breaks a link mid-word */}
        <nav className="flex flex-wrap items-center gap-x-7 gap-y-3">
          <Link to="/about" className={linkCls}>
            About us
          </Link>
          <a href="/#enrich-iq" className={linkCls}>
            Enrich IQ
          </a>
          <Link to="/contact" data-testid="footer-contact-link" className={linkCls}>
            Contact
          </Link>
          <Link to="/blog" data-testid="footer-blog-link" className={linkCls}>
            Blog
          </Link>
          <a href="/#playbook" className={linkCls}>
            Playbook
          </a>
          <Link to="/privacy" className={linkCls}>
            Privacy
          </Link>
          <Link to="/terms" data-testid="footer-terms-link" className={linkCls}>
            Terms
          </Link>
          <Link to="/do-not-sell" data-testid="footer-do-not-sell-link" className={linkCls}>
            Do Not Sell My Info
          </Link>
          <a
            href="https://www.linkedin.com/company/5dbs"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="5DBS on LinkedIn"
            data-testid="footer-linkedin-link"
            className="inline-flex items-center justify-center h-9 w-9 rounded-full border border-slate-200 text-body-muted hover:text-white hover:bg-brand-blue hover:border-brand-blue transition-colors"
          >
            <Linkedin className="h-4 w-4" />
          </a>
        </nav>
      </div>

      <div className="max-w-6xl mx-auto px-6 lg:px-8 mt-6 pt-6 border-t border-slate-100 text-body-muted text-[12.5px] text-center sm:text-left">
        © {new Date().getFullYear()} 5DBS. All rights reserved.
      </div>
    </footer>
  );
};

export default Footer;
